// extracted by mini-css-extract-plugin
export var deliveryRow = "_lc-a";
export var fixedHeight = "_lc-4";
export var freightLogo = "_lc-9";
export var fullWidth = "_lc-3";
export var priceColumn = "_lc-5";
export var radioSelected = "_lc-7";
export var radioUnselected = "_lc-6";
export var selectedOption = "_lc-2";
export var selectedOptionContainer = "_lc-1";
export var selection = "_lc-0";
export var tallSkeletonText = "_lc-8";